// extracted by mini-css-extract-plugin
export default {"countryWrapper":"CountriesList_countryWrapper__HQVPz"};